import { createAction } from "@reduxjs/toolkit";

export const actionCreators = {
  bootIntercom: createAction("lwc/intercom/boot"),
  setIntercomTimestamp: createAction<number>("lwc/intercom/updateTs"),
  shutdownIntercom: createAction("lwc/intercom/shutdown"),
  pauseIntercom: createAction("lwc/intercom/pause"),
  resumeIntercom: createAction("lwc/intercom/resume"),
};
